import React, { memo, useState, useEffect } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import AdminSideBar from "../shared/AdminSidebar";
import AdminHeader from "../shared/AdminHeader";
import { useSelector } from "react-redux";
import { setTitle } from "../../helpers/MetaTag";
import Container from "../../components/shared/Container";

const AdminLayout = ({ metaTitle }) => {
  const settings = useSelector((state) => state?.settings?.data);
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    setTitle(
      `${
        session?.user?.role?.toLowerCase() === "user" ? "User" : "Admin"
      } | ${metaTitle}`
    );
  }, [metaTitle, session]);

  useEffect(() => {
    if (settings?.favicon?.url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      link.href = settings?.favicon?.url;
    }
  }, [settings]);

  return (
    <div className="h-screen max-h-full w-screen overflow-hidden flex flex-col bg-[#F5F3FF]">
      <AdminHeader />
      <Container
        className={"items-start gap-x-5 py-4 max-h-[calc(100vh-100px)]"}
      >
        <div className="w-full max-w-[70px] p-2 overflow-x-hidden h-full flex-grow bg-white rounded-xl">
          <AdminSideBar />
        </div>
        <div className="flex-grow w-full max-w-[calc(100%-70px)] h-full overflow-auto scrollbar rounded-xl">
          <Outlet />
        </div>
      </Container>
    </div>
  );
};

export default memo(AdminLayout);
